import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";

const useCountry = (c = "IN") => {
  const { country } = useSelector(
    ({ appData }: AppState) => ({
      country: appData.country,
    }),
    shallowEqual,
  );
  return country || c;
};

export default useCountry;
